import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Card from '@components/card'
import Title from '@components/text/title'
import FormInput from '@components/inputs/formInput'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '@components/loading'
import Footer from '@components/footer'
import SubText from '@components/text/subText'
import Switch from '@components/inputs/switch'
import InsurerLogo from '@components/insurerLogo'
import showToast from '@util/ToastUtil'

import colors from '@settings/styleSettings'
import { UserRoles } from '@util/UserRolesEnum'

import backgroundImage from '@assets/images/login-background.jpg'
import { login as loginAction } from '@actions/user'
import { getAuth as getAuthAction } from '@actions/auth'

import {
  Container, GreenContainer, CardContainer
} from '../styles'
import { SaveArea, SwitchArea, ButtonArea } from './styles'

const Login = ({
  login, getAuth, loggedIn, authData
}) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('user'))
  const navigate = useNavigate()
  const { insurance } = useParams()

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      setUsername(user.username)
      setPassword(user.password)
    }
  }, [])

  useEffect(() => {
    if (loggedIn) {
      getAuth()
    }
  }, [loggedIn])

  useEffect(() => {
    if (authData) {
      goToList()
    }
  }, [authData])

  const onChangeRememberMe = () => setRememberMe(!rememberMe)

  const goToList = () => {
    if (rememberMe) {
      localStorage.setItem('user', JSON.stringify({ username, password }))
    } else {
      localStorage.removeItem('user')
    }
    const {
      company, programme, insurer, role
    } = authData
    if (role.level >= UserRoles.operator.level) {
      if (company) {
        navigate(`/${insurer.urlId}/acompanhamento/empresa/${company.endPoint}`)
      } else if (programme) {
        navigate(`/${insurer.urlId}/acompanhamento/programa/${programme.endPoint}`)
      } else {
        navigate(`/${insurer.urlId}/acompanhamento/empresas`)
      }
    } else {
      showToast('error', 'Perfil não possui permissão de visualização')
    }

    setLoading(false)
  }

  const onLogin = () => {
    setLoading(true)
    login({ email: username, password }, () => setLoading(false))
  }

  const handleNavigateRecoverPassword = () => {
    navigate(`/${insurance}/recuperar-senha`)
  }

  const onInputChange = (e, setState) => setState(e.target.value)

  return (
    <Container
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <GreenContainer>
        <InsurerLogo />
        <Card style={{ maxHeight: 300 }}>
          <CardContainer>
            <Title style={{ margin: '20px 0' }}>Entrar na conta</Title>
            <FormInput
              placeholder="Email"
              value={username}
              onChange={(e) => onInputChange(e, setUsername)}
            />
            <FormInput
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => onInputChange(e, setPassword)}
            />
            <SaveArea>
              <SwitchArea>
                <Switch checked={rememberMe} onChange={onChangeRememberMe} />
                <SubText style={{ color: colors.titleStrongBlack }}>
                  Lembrar de mim
                </SubText>
              </SwitchArea>
              <ButtonArea onClick={handleNavigateRecoverPassword}>
                <SubText style={{ color: colors.primary }}>
                  Esqueci minha senha
                </SubText>
              </ButtonArea>
            </SaveArea>
            <PrimaryButton onClick={onLogin} disabled={loading}>
              {loading ? <Loading /> : 'Entrar'}
            </PrimaryButton>
          </CardContainer>
        </Card>
        <Footer />
      </GreenContainer>
    </Container>
  )
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool,
  authData: PropTypes.shape({
    company: PropTypes.shape({
      endPoint: PropTypes.string
    }),
    programme: PropTypes.shape({
      id: PropTypes.number,
      endPoint: PropTypes.string
    }),
    insurer: PropTypes.shape({
      urlId: PropTypes.string
    }),
    role: PropTypes.shape({
      id: PropTypes.number,
      level: PropTypes.number
    })
  })
}

Login.defaultProps = {
  loggedIn: false,
  authData: null
}

const mapStateToProps = ({ auth, user }) => ({
  authData: auth.data,
  loggedIn: user.loggedIn
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    login: loginAction,
    getAuth: getAuthAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Login)
